import React from "react";
import { createStyles, makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return createStyles({
        grid: (_b = {
                display: "grid",
                gap: 16
            },
            _b[breakpoints.up("sm")] = {
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _b[breakpoints.up("md")] = {
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            _b),
        item: {
            display: "flex",
            padding: 8,
            backgroundColor: "#fff",
            borderRadius: 4,
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        },
        imageWrapper: {
            position: "relative",
            flexBasis: 120,
            minWidth: 120,
            minHeight: 120,
            display: "grid",
            placeItems: "center",
            "& > div": {
                position: "absolute",
                display: "grid",
                placeItems: "center",
            },
        },
        placeholder: {
            top: 2,
            left: 2,
            width: "calc(100% - 4px)",
            height: "calc(100% - 4px)",
            backgroundColor: "#333",
            borderRadius: 4,
        },
        image: {
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#f5f5f5",
            "& > img": {
                borderRadius: 4,
            },
        },
        content: {
            display: "flex",
            flexDirection: "column",
            marginLeft: 8,
        },
        title: {
            margin: 0,
            marginBottom: 4,
            fontSize: 16,
            fontWeight: 800,
            lineHeight: 1,
        },
        description: {
            fontSize: 13,
            lineHeight: "16px",
        },
        link: {
            fontSize: 13,
            marginTop: "auto",
        },
    });
});
var BrandsGrid = function (_a) {
    var products = _a.products;
    var styles = useStyles();
    return (React.createElement("div", { className: styles.grid }, products.map(function (_a, index) {
        var thumbnail = _a.thumbnail, title = _a.title, description = _a.description, url = _a.external_link;
        return (React.createElement("a", { key: index, id: "crossPromo" + title.replace(/\s*\W*/g, ""), href: url, target: "_blank", rel: "noopener noreferrer" },
            React.createElement("div", { className: styles.item },
                React.createElement("div", { className: styles.imageWrapper },
                    React.createElement("div", { className: styles.placeholder },
                        React.createElement("img", { src: "https://acm-assets.eco.astro.com.my/images/placeholder_image.svg", alt: "Placeholder", width: "34", height: "24", loading: "lazy" })),
                    React.createElement("div", { className: styles.image },
                        React.createElement("img", { src: thumbnail, alt: title, width: "120", height: "120", loading: "lazy" }))),
                React.createElement("div", { className: styles.content },
                    React.createElement("h2", { className: styles.title }, title),
                    React.createElement("p", { className: styles.description }, description),
                    React.createElement("p", { className: styles.link }, url)))));
    })));
};
export default BrandsGrid;
